<template>
    <v-container
        id="recipe"
        class="white pt-0"
    >

        <v-tooltip
            left
        >
            <template v-slot:activator="{ on: tooltip}">
                <v-btn
                    small
                    fab
                    fixed
                    top
                    right
                    @click="closeRecipe"
                    v-on="{ ...tooltip}"
                    style="top: 10px; right: 25px;"
                >
                    <v-icon>
                        close
                    </v-icon>
                </v-btn>
            </template>
            <span>
                Close
            </span>
        </v-tooltip>

        <v-tooltip
            v-if="adminView"
            left
        >
            <template v-slot:activator="{ on: tooltip}">
                <v-btn
                    small
                    fab
                    fixed
                    top
                    right
                    @click="editRecipe = true"
                    v-on="{ ...tooltip}"
                    style="top: 60px; right: 25px;"
                >
                    <v-badge
                        v-if="thisRecipe.audited == null && adminView == true"
                        avatar
                        bordered
                        overlap
                    >
                        <template v-slot:badge>
                            <v-avatar
                                color="error"
                            >
                                <v-icon
                                    small
                                >
                                    priority_high
                                </v-icon>
                            </v-avatar>
                        </template>
                
                        <v-avatar
                            size="40"
                        >
                            <v-icon>
                                edit
                            </v-icon>
                        </v-avatar>
                    </v-badge>
                    <v-icon
                        v-if="thisRecipe.audited != null || adminView == false"
                    >
                        edit
                    </v-icon>
                </v-btn>
            </template>
            <span>
                Edit
            </span>
        </v-tooltip>


                <!--------------------------------->
                <!--      Set Content Width      -->
                <!--------------------------------->
        <v-row
            justify="center"
            class="mt-5"
            no-gutters
        >
            <v-col
                xs="12"
                sm="12"
                md="10"
                lg="8"
                xl="6"
            >

                <!--------------------------------->
                <!--         Recipe Title        -->
                <!--------------------------------->
                <v-row
                    justify="center"
                    class="black--text"
                    no-gutters
                    style="font-size: 1.8em; font-weight: 600; color: #212121; letter-spacing: 1px;"
                >
                    <v-col
                        cols="10"
                        class="text-center pa-0"
                    >
                        {{ thisRecipe.name }}
                    </v-col>
                </v-row>

                <!--------------------------------->
                <!--           Picture           -->
                <!--------------------------------->
                <v-row
                    class="mt-5"
                    justify="center"
                    no-gutters
                >
                    <v-col>
                        <v-img
                            :src="thisRecipe.photo_url"
                            aspect-ratio="1.8"
                        />
                    </v-col>
                </v-row>
                <v-row
                    no-gutters
                    style="font-size: 0.8em; font-weight: 400; color: #757575;"
                >
                    <v-col
                        v-if="thisRecipeSource.type == 'Website'"
                        class="text-left"
                    >
                        Recipe From: 
                            <a
                                :href="thisRecipe.recipe_source_url"
                                target="blank"
                                style="color: #757575"
                            >
                                {{ thisRecipeSource.source_name }}
                            </a>
                    </v-col>
                    <v-col
                        v-else
                        class="text-left"
                    >
                        Recipe From: {{ thisRecipeSource.source_name }}
                    </v-col>
                    <v-col
                        class="text-right"
                    >
                        Photo by: {{ thisRecipe.photo_credit }}
                    </v-col>
                </v-row>

                <!--------------------------------->
                <!--      Under-Picture Menu     -->
                <!--------------------------------->
                <v-row
                    class="black--text pr-2 mt-1"
                    align="center"
                    no-gutters
                >
                    <v-col
                        class="text-left text-no-wrap pa-0 ml-2"
                    >
                         <v-icon
                            color="grey darken-3"
                        >
                            av_timer
                        </v-icon>
                            <div
                                class="d-inline mr-1 caption"
                            >
                                {{thisRecipe.prep_time_min}}
                            </div>
                        <!-- <v-icon color="grey darken-3">
                            attach_money
                        </v-icon>
                            <div class="d-inline mr-1 caption">{{cost}}</div> -->
                        <v-btn
                            icon
                        >
                            <v-icon
                                :color="likeColor"
                                @click.prevent="like"
                            >
                                thumb_up
                            </v-icon>
                        </v-btn>
                        <v-btn
                            icon
                        >
                            <v-icon
                                :color="dislikeColor"
                                @click.prevent="dislike"
                            >
                                thumb_down
                            </v-icon>
                        </v-btn>
                        <div
                            class="d-inline mr-1 caption font-weight-black"
                        >
                            {{rating}}% Positive
                        </div>
                    </v-col>

                    <!-- this section is intended for swapping out the recipe if it's on an unapproved menu. change approach here.. -->
                    <!-- <v-col
                        class="text-right text-no-wrap pa-0"
                    >
                        <v-btn
                            v-if="!savedMenu"
                            fab
                            color="blue"
                            small
                        >
                            <v-icon color="white" medium>
                                edit
                            </v-icon>
                        </v-btn>
                        <v-btn
                            v-else
                            icon
                            @click.prevent="printRecipe('recipe')"
                        >
                            <v-icon
                                color="grey darken-3"
                            >
                                print
                            </v-icon>
                        </v-btn>
                    </v-col> -->

                    <v-col
                        class="text-right text-no-wrap pa-0"
                    >
                        <v-btn
                            icon
                            @click.prevent="printRecipe('recipe')"
                        >
                            <v-icon
                                color="grey darken-3"
                            >
                                print
                            </v-icon>
                        </v-btn>
                    </v-col>

                    <v-col
                        cols="1"
                        class="text-right text-no-wrap pa-0 d-none"
                    >
                        <v-btn
                            icon
                            @click.prevent="printWindow()"
                        >
                            <v-icon
                                color="grey darken-3"
                            >
                                print
                            </v-icon>
                        </v-btn>
                     </v-col>
                </v-row>
            

                <!--------------------------------->
                <!--        Recipe Content       -->
                <!--------------------------------->
                <v-row
                    align="center"
                    class="black--text mt-5"
                    no-gutters
                >
                <!--      ingredients      -->
                    <v-col
                        class="pb-0"
                        style="font-size: 1.2em; font-weight: 600; color: #000000;"
                    >
                        Ingredients:
                    </v-col>
                </v-row>
                <v-row
                    no-gutters
                >
                    <v-col
                        class="ml-5"
                    >
                        <table>
                            <tbody>
                                <tr
                                    v-for="(ingredient,i) in thisRecipeIngredients"
                                    :key="i"
                                    class="ml-5 body-2"
                                >
                                    <td
                                        style="vertical-align: center"
                                    >
                                        <v-checkbox
                                            color="#74cf74"
                                            class="ma-0 pa-0"
                                            hide-details
                                        ></v-checkbox>
                                    </td>
                                    <td
                                        style="vertical-align: center"
                                    >
                                        <div
                                            class="mr-2 text-no-wrap"
                                        >
                                            {{quantityDisplay(ingredient.quantity)}} {{ingredient.display_unit}}
                                        </div>
                                    </td>
                                    <td
                                        style="vertical-align: center"
                                    >
                                        <b>{{nameDisplay({name: ingredient.name, quantity: ingredient.quantity, plural: ingredient.plural})}}</b> {{prepDisplay(ingredient.preparation)}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </v-col>
                </v-row>

                <!--      directions      -->
                <v-row
                    align="center"
                    class="black--text mt-5"
                    no-gutters
                >
                    <v-col
                        class="pb-0"
                        style="font-size: 1.2em; font-weight: 600; color: #000000;"
                    >
                        Directions:
                    </v-col>
                </v-row>
                <v-row
                    no-gutters
                >
                    <v-col
                        class="ml-5"
                    >
                        <table
                            vertical-align="top"
                        >
                            <tbody>
                                <tr
                                    v-for="(direction,i) in thisRecipeStepDirections"
                                    :key="i"
                                    class="ml-5 body-2"
                                >
                                     <td
                                        style="vertical-align: center"
                                    >
                                        <v-checkbox
                                            color="#74cf74"
                                            class="ma-0 pa-0"
                                            hide-details
                                        ></v-checkbox>
                                    </td>
                                    <td
                                        style="vertical-align: center"
                                    >
                                        <div
                                            class="mr-2 text-no-wrap"
                                        >
                                            {{direction.step_number}}.
                                        </div>
                                    </td>
                                    <td
                                        style="vertical-align: center"
                                    >
                                        {{direction.directions}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </v-col>
                </v-row>

                <!------------------------------>
                <!--      nutrition info      -->
                <!------------------------------>
                <v-row
                    class="mt-10"
                    no-gutters
                    justify="start"
                    style="font-size: 1.2em; font-weight: 600; color: #000000;"
                >    
                    Nutrition Information:
                </v-row>
                <v-row
                    justify="center"
                    no-gutters
                >
                    <v-col
                        class="my-5 px-5"
                        cols="12"
                        xs="12"
                        sm="12"
                        md="6"
                        lg="6"
                        xl="6"
                    >
                        <v-simple-table dense>
                            <template v-slot:default>
                                <tbody>
                                    <tr>
                                        <td colspan="2" class="black"/>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div
                                                class="font-weight-bold"
                                            >
                                                Total Recipe Calories
                                            </div>
                                        </td>
                                        <td
                                            class='text-right'
                                        >
                                            {{thisRecipeNutrition.totalCalories}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="black"/>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div
                                                class="ml-0 font-weight-bold"
                                            >
                                                Total Fat
                                            </div></td>
                                        <td
                                            class="text-right"
                                        >
                                            {{thisRecipeNutrition.totalFat}} g
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div
                                                class="ml-4 font-weight-regular"
                                            >
                                                Saturated Fat
                                            </div></td>
                                        <td
                                            class="text-right"
                                        >
                                            {{thisRecipeNutrition.saturatedFat}} g
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div
                                                class="ml-4 font-weight-regular"
                                            >
                                                Trans Fat
                                            </div></td>
                                        <td
                                            class="text-right"
                                        >
                                            {{thisRecipeNutrition.transFat}} g
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div
                                                class="ml-4 font-weight-regular"
                                            >
                                                Polyunsaturated Fat
                                            </div></td>
                                        <td
                                            class="text-right"
                                        >
                                            {{thisRecipeNutrition.polyunsaturatedFat}} g
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div
                                                class="ml-4 font-weight-regular"
                                            >
                                                Monounsaturated Fat
                                            </div></td>
                                        <td
                                            class="text-right"
                                        >
                                            {{thisRecipeNutrition.monounsaturatedFat}} g
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div
                                                class="ml-0 font-weight-bold"
                                            >
                                                Cholesterol
                                            </div></td>
                                        <td
                                            class="text-right"
                                        >
                                            {{thisRecipeNutrition.cholesterol}} mg
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div
                                                class="ml-0 font-weight-bold"
                                            >
                                                Sodium
                                            </div></td>
                                        <td
                                            class="text-right"
                                        >
                                            {{thisRecipeNutrition.sodium}} mg
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div
                                                class="ml-0 font-weight-bold"
                                            >
                                                Total Carbohydrate
                                            </div></td>
                                        <td
                                            class="text-right"
                                        >
                                            {{thisRecipeNutrition.totalCarbohydrate}} g
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div
                                                class="ml-4 font-weight-regular"
                                            >
                                                Dietary Fiber
                                            </div></td>
                                        <td
                                            class="text-right"
                                        >
                                            {{thisRecipeNutrition.dietaryFiber}} g
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div
                                                class="ml-4 font-weight-regular"
                                            >
                                                Sugars
                                            </div></td>
                                        <td
                                            class="text-right"
                                        >
                                            {{thisRecipeNutrition.sugars}} g
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div
                                                class="ml-0 font-weight-bold"
                                            >
                                                Protein
                                            </div></td>
                                        <td
                                            class="text-right"
                                        >
                                            {{thisRecipeNutrition.protein}} g
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="black"/>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                    <v-col
                        class="my-5 px-5"
                        cols="12"
                        xs="12"
                        sm="12"
                        md="6"
                        lg="6"
                        xl="6"
                    >
                        <v-row
                            justify="center"
                            no-gutters
                            style="font-size: 0.9em; font-weight: 500; color: #000000;"
                        >
                            % of Calories from Macros
                        </v-row>
                        <v-row
                            justify="center"
                        >
                            <div 
                                style="width: 100%; height: 300px; pointer-events: none;"
                                ref="chartdiv"
                            />
                        </v-row>
                    </v-col>
                </v-row>

                
                <!------------------------------>
                <!--         portions         -->
                <!------------------------------>
                <v-row
                    v-if="showPortions"
                    class="my-10"
                    no-gutters
                >
                    <v-col
                        cols="12"
                    >
                        <v-expansion-panels
                            v-model="expansionPanels"
                            hover
                            popout
                            focusable
                        >
                        
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <v-col
                                        class="text-left"
                                        style="font-size: 1.2em; font-weight: 600; color: #212121;"
                                    >
                                        Portions
                                    </v-col>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row
                                        justify="center"
                                        no-gutters
                                    >
                                        <v-col
                                            cols="12"
                                            xs="12"
                                            sm="12"
                                            md="6"
                                            lg="6"
                                            xl="6"
                                            class="py-0"
                                        >
                                            <ChartRecipeMealSplit/>
                                        </v-col>
                                    </v-row>
                                    <v-row
                                        v-if="showPortions"
                                        align="center"
                                        class="black--text mt-5"
                                        no-gutters
                                    >
                                        <v-col
                                            class="pb-0"
                                        >
                                            <h3>Portion Calculator:</h3>
                                        </v-col>
                                    </v-row>
                                    <v-row
                                        no-gutters
                                    >
                                        <v-col
                                            cols="7"
                                            class="pl-5 pr-1 mb-0 pb-0"
                                        >
                                            <v-text-field
                                                v-model="recipeSize"
                                                label="Measured Recipe Size"
                                                outlined
                                                type="number"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col
                                            cols="5"
                                            class="pr-5 pl-1 mb-0 pb-0"
                                        >
                                            <v-select
                                                v-model="units"
                                                :items="unitOptions"
                                                item-text="unit"
                                                item-value="unit"
                                                label="Units"
                                                outlined
                                            ></v-select>
                                        </v-col>
                                    </v-row>

                                    <v-row
                                        align="center"
                                        class="black--text"
                                        v-if="showBreakdown"
                                        no-gutters
                                    >
                                        <v-col
                                            class="pb-0 mb-0"
                                        >
                                            <CalculatorMealFamilySplit/>
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-col>
                </v-row>

            </v-col>    <!-- end content width -->
        </v-row>
    </v-container>
</template>


<script>
import ChartRecipeMealSplit from '@/components/menu/Chart_RecipeMealSplit.vue'
import CalculatorMealFamilySplit from '@/components/menu/Calculator_MealFamilySplit.vue'

//used for recipe chart of calories from fat, carbs, protein
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
am4core.useTheme(am4themes_animated);


//let moment = require('moment');

export default {
    components: {
        ChartRecipeMealSplit,
        CalculatorMealFamilySplit,
    },


    mounted() {
        let chart = am4core.create(this.$refs.chartdiv, am4charts.PieChart);

        chart.data = [
            {
              source: "Fat",
              percent: this.thisRecipe.percent_calories_from_fat,
              color: am4core.color("#cfa274")
            },
            {
              source: "Protein",
              percent: this.thisRecipe.percent_calories_from_protein,
              color: am4core.color("#74cf74")
            },
            {
              source: "Carbs",
              percent: this.thisRecipe.percent_calories_from_carbs,
              color: am4core.color("#cf74cf")
            },
        ];

        //add and configure series
        let pieSeries = chart.series.push(new am4charts.PieSeries());
        pieSeries.dataFields.value = "percent";
        pieSeries.dataFields.category = "source";
        
        //disable interactivity of chart -- disabled by pointer-events: none
        //pieSeries.slices.template.states.getKey("hover").properties.scale = 1;
        //pieSeries.slices.template.states.getKey("active").properties.shiftRadius = 0;

        // Set up slices
        pieSeries.slices.template.tooltipText = "";
        pieSeries.slices.template.alwaysShowTooltip = true;

        //add outline
        pieSeries.slices.template.stroke = am4core.color("#424242");
        pieSeries.slices.template.strokeWidth = 2;
        pieSeries.slices.template.strokeOpacity = 1;

        //move and format labels inside pie slice
        pieSeries.ticks.template.disabled = true;
        pieSeries.alignLabels = false;
        pieSeries.labels.template.text = "{category} \n {value}%";
        pieSeries.labels.template.radius = am4core.percent(-50);
        pieSeries.labels.template.fill = am4core.color("black");
        //pieSeries.labels.template.relativeRotation = 90;

        //color pie slices
        pieSeries.slices.template.propertyFields.fill = "color"

    },

    beforeDestroy() {
        if (this.chart) {
        this.chart.dispose();
        }
    },

    data: () => ({
        ////////////////////////////////  old data
        rating: 95,

        ////////////////////////////////  new data
        expansionPanels: false,
        likeColor: "grey darken-3",
        dislikeColor: "grey darken-3",
        units: [],
        refender: 0,
        //moment: moment,
    }),

    methods: {
        ////////////////////////////////  old data
        printWindow(){
            window.print();
        },
        printRecipe(printpage) {
            var headstr = "<html><head><title></title></head><body>";
            var footstr = "</body>";
            var newstr = document.all.item(printpage).innerHTML;
            var oldstr = document.body.innerHTML;
            document.body.innerHTML = headstr + newstr + footstr;
            window.print();
            document.body.innerHTML = oldstr;
            return false;
        },
        

        ////////////////////////////////  new data
        like() {
            this.likeColor = "green";
            this.dislikeColor = "grey darken-3"
        },
        dislike() {
            this.likeColor = "grey darken-3";
            this.dislikeColor = "red"
        },
        nameDisplay(value) {
            if(value.plural != null && value.quantity > 1){
                return value.plural
            } else {
                return value.name
            }
        },
        prepDisplay(value) {
            if (value == null || value == '') {
                return null;
            } else {
                return ' - ('+value+')';
            }
        },
        quantityDisplay(value){
            let num = Math.trunc(value)

            let prefix;
                if (num == 0) {
                    prefix = ""
                } else {
                    prefix = num.toString()
                }
            let suffix = ""

            if (Math.trunc((value - Math.trunc(value)) * 10000) == 625) {
                suffix == "1/16"
            } else if (Math.trunc((value - Math.trunc(value)) * 10000) == 1250) {
                suffix = "1/8"
            } else if (Math.trunc((value - Math.trunc(value)) * 10000) == 1875) {
                suffix = "3/16"
            } else if (Math.trunc((value - Math.trunc(value)) * 10000) == 2500) {
                suffix = "1/4"
            } else if (Math.trunc((value - Math.trunc(value)) * 10000) == 3125) {
                suffix = "5/16"
            } else if (Math.trunc((value - Math.trunc(value)) * 10000) == 3333) {
                suffix = "1/3"
            } else if (Math.trunc((value - Math.trunc(value)) * 10000) == 3750) {
                suffix = "3/8"
            } else if (Math.trunc((value - Math.trunc(value)) * 10000) == 4375) {
                suffix = "7/16"
            } else if (Math.trunc((value - Math.trunc(value)) * 10000) == 5000) {
                suffix = "1/2"
            } else if (Math.trunc((value - Math.trunc(value)) * 10000) == 5625) {
                suffix = "9/16"
            } else if (Math.trunc((value - Math.trunc(value)) * 10000) == 6250) {
                suffix = "5/8"
            } else if (Math.trunc((value - Math.trunc(value)) * 10000) == 6666) {
                suffix = "2/3"
            } else if (Math.trunc((value - Math.trunc(value)) * 10000) == 6875) {
                suffix = "11/16"
            } else if (Math.trunc((value - Math.trunc(value)) * 10000) == 7500) {
                suffix = "3/4"
            } else if (Math.trunc((value - Math.trunc(value)) * 10000) == 8125) {
                suffix = "13/16"
            } else if (Math.trunc((value - Math.trunc(value)) * 10000) == 8750) {
                suffix = "7/8"
            } else if (Math.trunc((value - Math.trunc(value)) * 10000) == 9375) {
                suffix = "15/16"
            }

            if (suffix == ""){
                return value;
            } else if (prefix == "") {
                return suffix;
            } else {
                return prefix.concat(" ",suffix)
            }
        },
        closeRecipe() {
            this.recipeDialog = false;
            this.rerender += 1;
        },


    },

    computed: {
        ////////////////////////////////  old data

        
        // savedMenu() {
        //     return this.$store.getters['menu/savedMenu'];
        // },

        ////////////////////////////////  new data
        adminView() {
            return this.$store.getters['data/adminView'];
        },
        recipes() {
            return this.$store.getters['data/recipe'];
        },
        recipeIngredientJunctions() {
            return this.$store.getters['data/recipeIngredientJunction'];
        },
        ingredients() {
            return this.$store.getters['data/ingredient'];
        },
        recipeSources() {
            return this.$store.getters['data/recipeSource'];
        },
        recipeStepDirections() {
            let directions = this.$store.getters['data/recipeStepDirections'];
            return directions.sort((a,b) => (a.step_number > b.step_number) ? 1 : -1);
        },
        unitOptions() {
            return this.$store.getters['data/conversionChart'];
        },
        recipeSize: {
            get(){
                return this.$store.getters['menu/recipeSize'];
            },
            set(value) {
                this.$store.dispatch('menu/updateRecipeSize',value)
            }
        },
        showBreakdown() {
            if (this.recipeSize > 0 && this.units.length > 0)
                return true
            else
                return false
        },
        conversionChart() {
            return this.$store.getters['data/conversionChart'];
        },
        conversionChartLength() {
            return this.conversionChart.length
        },
        selectedRecipeID() {
            return this.$store.getters['data/selectedRecipeID'];
        },
        thisRecipe() {
            return this.$store.getters['data/thisRecipe'];
        },
        thisRecipeSource() {
            let response = null
            for (let i=0; i < this.recipeSources.length; i++) {
                if (this.recipeSources[i].id == this.thisRecipe.recipe_source_lookup) {
                    response = this.recipeSources[i];
                }
            }
            return response;
        },
        thisRecipeIngredients() {
            let response = [];
            let entry = {};
            let multiplier = 0;

            for (let i=0; i < this.recipeIngredientJunctions.length; i++) {
                if(this.recipeIngredientJunctions[i].recipe_lookup == this.selectedRecipeID) {
                    for (let j=0; j < this.ingredients.length; j++) {
                        if (this.ingredients[j].id == this.recipeIngredientJunctions[i].ingredient_lookup) {

                            // calculate nutrition information multiplier
                            for (let iu = 0; iu < this.conversionChartLength; iu++) {
                                if (this.conversionChart[iu].unit == this.recipeIngredientJunctions[i].unit) {
                                    for (let ju = 0; ju < this.conversionChartLength; ju++) {
                                        if (this.conversionChart[ju].unit == this.ingredients[j].measurement_unit) {
                                            multiplier = (this.conversionChart[ju].quantity / this.conversionChart[iu].quantity);
                                            ju = this.conversionChartLength;
                                            iu = this.conversionChartLength;
                                        }
                                    }
                                }
                            }

                            // add ingredient to list of ingredients for this recipe
                            entry = this.recipeIngredientJunctions[i];
                            entry.name = this.ingredients[j].name;
                            entry.plural = this.ingredients[j].plural;
                            entry.grocery_store_section = this.ingredients[j].grocery_store_section;

                            // calculate nutrition information for this ingredient and add to dataset for ingredient
                            entry.totalCalories = (this.recipeIngredientJunctions[i].quantity * this.ingredients[j].unit_calories * multiplier);
                            entry.caloriesFromFat = (this.recipeIngredientJunctions[i].quantity * this.ingredients[j].unit_calories_from_fat * multiplier);
                            entry.caloriesFromCarbs = (this.recipeIngredientJunctions[i].quantity * this.ingredients[j].unit_calories_from_carbohydrate * multiplier);
                            entry.caloriesFromProtein = (this.recipeIngredientJunctions[i].quantity * this.ingredients[j].unit_calories_from_protein * multiplier);
                            entry.totalFat = (this.recipeIngredientJunctions[i].quantity * this.ingredients[j].unit_grams_total_fat * multiplier);
                            entry.saturatedFat = (this.recipeIngredientJunctions[i].quantity * this.ingredients[j].unit_grams_saturated_fat * multiplier);
                            entry.transFat = (this.recipeIngredientJunctions[i].quantity * this.ingredients[j].unit_grams_trans_fat * multiplier);
                            entry.polyunsaturatedFat = (this.recipeIngredientJunctions[i].quantity * this.ingredients[j].unit_grams_polyunsaturated_fat * multiplier);
                            entry.monounsaturatedFat = (this.recipeIngredientJunctions[i].quantity * this.ingredients[j].unit_grams_monounsaturated_fat * multiplier);
                            entry.cholesterol = (this.recipeIngredientJunctions[i].quantity * this.ingredients[j].unit_milligrams_cholesterol * multiplier);
                            entry.sodium = (this.recipeIngredientJunctions[i].quantity * this.ingredients[j].unit_milligrams_sodium * multiplier);
                            entry.totalCarbohydrate = (this.recipeIngredientJunctions[i].quantity * this.ingredients[j].unit_grams_total_carbohydrate * multiplier);
                            entry.dietaryFiber = (this.recipeIngredientJunctions[i].quantity * this.ingredients[j].unit_grams_dietary_fibers * multiplier);
                            entry.sugars = (this.recipeIngredientJunctions[i].quantity * this.ingredients[j].unit_grams_sugars * multiplier);
                            entry.protein = (this.recipeIngredientJunctions[i].quantity * this.ingredients[j].unit_grams_protein * multiplier);

                            response.push(entry);
                        }
                    }
                }
            }
            return response.sort((a,b) => (a.grocery_store_section > b.grocery_store_section) ? 1 : -1);
        },
        thisRecipeNutrition() {
            let response = {
                totalCalories: null,
                totalFat: null,
                saturatedFat: null,
                transFat: null,
                polyunsaturatedFat: null,
                monounsaturatedFat: null,
                cholesterol: null,
                sodium: null,
                totalCarbohydrate: null,
                dietaryFiber: null,
                sugars: null,
                protein: null
            };
            let max = this.thisRecipeIngredients.length;

            for (let i=0; i < max; i++) {
                response.totalCalories += this.thisRecipeIngredients[i].totalCalories;
                response.totalFat += this.thisRecipeIngredients[i].totalFat;
                response.saturatedFat += this.thisRecipeIngredients[i].saturatedFat;
                response.transFat += this.thisRecipeIngredients[i].transFat;
                response.polyunsaturatedFat += this.thisRecipeIngredients[i].polyunsaturatedFat;
                response.monounsaturatedFat += this.thisRecipeIngredients[i].monounsaturatedFat;
                response.cholesterol += this.thisRecipeIngredients[i].cholesterol;
                response.sodium += this.thisRecipeIngredients[i].sodium;
                response.totalCarbohydrate += this.thisRecipeIngredients[i].totalCarbohydrate;
                response.dietaryFiber += this.thisRecipeIngredients[i].dietaryFiber;
                response.sugars += this.thisRecipeIngredients[i].sugars;
                response.protein += this.thisRecipeIngredients[i].protein;
            }

            //round entries
                response.totalCalories = Math.round(response.totalCalories);
                response.totalFat = Math.round(response.totalFat);
                response.saturatedFat = Math.round(response.saturatedFat);
                response.transFat = Math.round(response.transFat);
                response.polyunsaturatedFat = Math.round(response.polyunsaturatedFat);
                response.monounsaturatedFat = Math.round(response.monounsaturatedFat);
                response.cholesterol = Math.round(response.cholesterol);
                response.sodium = Math.round(response.sodium);
                response.totalCarbohydrate = Math.round(response.totalCarbohydrate);
                response.dietaryFiber = Math.round(response.dietaryFiber);
                response.sugars = Math.round(response.sugars);
                response.protein = Math.round(response.protein);

            return response

        },
        thisRecipeStepDirections() {
            let response = [];

            for (let i=0; i < this.recipeStepDirections.length; i++) {
                if (this.recipeStepDirections[i].recipe_lookup == this.selectedRecipeID) {
                    response.push(this.recipeStepDirections[i]);
                }
            }
            return response;
        },
        showPortions() {
            if (window.location.href.indexOf("menu") >= 0) {
                return true;
            } else {
                return false;
            }
        },
        recipeDialog: {
            get(){
                return this.$store.getters['data/recipeDialog'];
            },
            set(value) {
                this.$store.dispatch('data/updateRecipeDialog',value);
            }
        },
        rerender: {
            get(){
                return this.$store.getters['data/rerender'];
            },
            set(value) {
                this.$store.dispatch('data/forceRerender',value);
            }
        },
        editRecipe: {
            get(){
                return this.$store.getters['data/editRecipe'];
            },
            set(value) {
                this.$store.dispatch('data/updateEditRecipe',value);
            }
        }
    },

};
</script>
